export enum Country {
  Canada = 'Canada',
  UnitedStates = 'UnitedStates',
}

export enum Provinces {
  Saskatchewan = 'Saskatchewan',
  Alberta = 'Alberta',
  BritishColumbia = 'BritishColumbia',
  Manitoba = 'Manitoba',
  NewBrunswick = 'NewBrunswick',
  NewfoundlandAndLabrador = 'NewfoundlandAndLabrador',
  NorthwestTerritories = 'NorthwestTerritories',
  NovaScotia = 'NovaScotia',
  Ontario = 'Ontario',
  PrinceEdwardIsland = 'PrinceEdwardIsland',
  Quebec = 'Quebec',
  Nunavut = 'Nunavut',
  Yukon = 'Yukon',
}

export enum States {
  Alabama = 'Alabama',
  Alaska = 'Alaska',
  Arizona = 'Arizona',
  Arkansas = 'Arkansas',
  California = 'California',
  Colorado = 'Colorado',
  Connecticut = 'Connecticut',
  Delaware = 'Delaware',
  DistrictOfColumbia = 'DistrictOfColumbia',
  Florida = 'Florida',
  Georgia = 'Georgia',
  Hawaii = 'Hawaii',
  Idaho = 'Idaho',
  Illinois = 'Illinois',
  Indiana = 'Indiana',
  Iowa = 'Iowa',
  Kansas = 'Kansas',
  Kentucky = 'Kentucky',
  Louisiana = 'Louisiana',
  Maine = 'Maine',
  Maryland = 'Maryland',
  Massachusetts = 'Massachusetts',
  Michigan = 'Michigan',
  Minnesota = 'Minnesota',
  Mississippi = 'Mississippi',
  Missouri = 'Missouri',
  Montana = 'Montana',
  Nebraska = 'Nebraska',
  Nevada = 'Nevada',
  NewHampshire = 'NewHampshire',
  NewJersey = 'NewJersey',
  NewMexico = 'NewMexico',
  NewYork = 'NewYork',
  NorthCarolina = 'NorthCarolina',
  NorthDakota = 'NorthDakota',
  Ohio = 'Ohio',
  Oklahoma = 'Oklahoma',
  Oregon = 'Oregon',
  Pennsylvania = 'Pennsylvania',
  RhodeIsland = 'RhodeIsland',
  SouthCarolina = 'SouthCarolina',
  SouthDakota = 'SouthDakota',
  Tennessee = 'Tennessee',
  Texas = 'Texas',
  Utah = 'Utah',
  Vermont = 'Vermont',
  Virginia = 'Virginia',
  Washington = 'Washington',
  WestVirginia = 'WestVirginia',
  Wisconsin = 'Wisconsin',
  Wyoming = 'Wyoming',
}

export const CountryLabel: {
  [key in Country]: string;
} = {
  [Country.Canada]: 'Canada',
  [Country.UnitedStates]: 'United States',
};

export const ProvincesLabel: {
  [key in Provinces]: string;
} = {
  [Provinces.Saskatchewan]: 'Saskatchewan',
  [Provinces.Alberta]: 'Alberta',
  [Provinces.BritishColumbia]: 'British Columbia',
  [Provinces.Manitoba]: 'Manitoba',
  [Provinces.NewBrunswick]: 'New Brunswick',
  [Provinces.NewfoundlandAndLabrador]: 'Newfoundland And Labrador',
  [Provinces.NorthwestTerritories]: 'Northwest Territories',
  [Provinces.NovaScotia]: 'Nova Scotia',
  [Provinces.Ontario]: 'Ontario',
  [Provinces.PrinceEdwardIsland]: 'Prince Edward Island',
  [Provinces.Quebec]: 'Quebec',
  [Provinces.Nunavut]: 'Nunavut',
  [Provinces.Yukon]: 'Yukon',
};

export const StatesLabel: {
  [key in States]: string;
} = {
  [States.Alabama]: 'Alabama',
  [States.Alaska]: 'Alaska',
  [States.Arizona]: 'Arizona',
  [States.Arkansas]: 'Arkansas',
  [States.California]: 'California',
  [States.Colorado]: 'Colorado',
  [States.Connecticut]: 'Connecticut',
  [States.Delaware]: 'Delaware',
  [States.DistrictOfColumbia]: 'District Of Columbia',
  [States.Florida]: 'Florida',
  [States.Georgia]: 'Georgia',
  [States.Hawaii]: 'Hawaii',
  [States.Idaho]: 'Idaho',
  [States.Illinois]: 'Illinois',
  [States.Indiana]: 'Indiana',
  [States.Iowa]: 'Iowa',
  [States.Kansas]: 'Kansas',
  [States.Kentucky]: 'Kentucky',
  [States.Louisiana]: 'Louisiana',
  [States.Maine]: 'Maine',
  [States.Maryland]: 'Maryland',
  [States.Massachusetts]: 'Massachusetts',
  [States.Michigan]: 'Michigan',
  [States.Minnesota]: 'Minnesota',
  [States.Mississippi]: 'Mississippi',
  [States.Missouri]: 'Missouri',
  [States.Montana]: 'Montana',
  [States.Nebraska]: 'Nebraska',
  [States.Nevada]: 'Nevada',
  [States.NewHampshire]: 'New Hampshire',
  [States.NewJersey]: 'New Jersey',
  [States.NewMexico]: 'New Mexico',
  [States.NewYork]: 'New York',
  [States.NorthCarolina]: 'North Carolina',
  [States.NorthDakota]: 'North Dakota',
  [States.Ohio]: 'Ohio',
  [States.Oklahoma]: 'Oklahoma',
  [States.Oregon]: 'Oregon',
  [States.Pennsylvania]: 'Pennsylvania',
  [States.RhodeIsland]: 'Rhode Island',
  [States.SouthCarolina]: 'South Carolina',
  [States.SouthDakota]: 'South Dakota',
  [States.Tennessee]: 'Tennessee',
  [States.Texas]: 'Texas',
  [States.Utah]: 'Utah',
  [States.Vermont]: 'Vermont',
  [States.Virginia]: 'Virginia',
  [States.Washington]: 'Washington',
  [States.WestVirginia]: 'West Virginia',
  [States.Wisconsin]: 'Wisconsin',
  [States.Wyoming]: 'Wyoming',
};
